// Keeps the header bag count in sync with the real cart.
window.keoUpdateCartBadge = function (cart) {
  var apply = function (c) {
    document.querySelectorAll('[aria-controls="cart-drawer"]').forEach(function (btn) {
      var existing = btn.querySelector('.keo-icon-btn__badge');
      if (c.item_count > 0) {
        if (!existing) {
          existing = document.createElement('span');
          existing.className = 'keo-icon-btn__badge';
          btn.appendChild(existing);
        }
        existing.textContent = c.item_count;
      } else if (existing) {
        existing.remove();
      }
    });
  };
  if (cart && typeof cart.item_count === 'number') return apply(cart);
  return fetch('/cart.js', { credentials: 'same-origin' })
    .then(function (r) { return r.json(); })
    .then(apply)
    .catch(function () {});
};

// Any cart change on the page (Horizon's cart drawer quantity/remove,
// quick add, our own add buttons) refreshes the badge, so it never shows a
// stale count.
(function () {
  if (!window.fetch || window.__keoCartFetchPatched) return;
  window.__keoCartFetchPatched = true;
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var nativeFetch = window.fetch;
  var timer = null;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch.apply(this, arguments);
    if (CART_WRITE.test(url)) {
      p.then(function () {
        clearTimeout(timer);
        timer = setTimeout(function () { window.keoUpdateCartBadge(); }, 150);
      }).catch(function () {});
    }
    return p;
  };
  // Also correct the count when a page is restored from the back/forward cache.
  window.addEventListener('pageshow', function (e) { if (e.persisted) window.keoUpdateCartBadge(); });
})();

// Silently applies a discount code to the checkout session (sets the same
// cookie a full navigation to /discount/{code} would, without leaving the
// page) so bundle/set prices shown in the UI are genuinely honoured at
// checkout rather than just being a display-only calculation.
window.keoApplyDiscount = function (code) {
  return fetch('/discount/' + encodeURIComponent(code), { credentials: 'include' }).catch(function () {});
};

// Shared helper: refreshes Horizon's cart drawer content after a custom
// /cart/add.js call (our custom sections don't go through Horizon's own
// product-form component, so its cart events never fire without this).
window.keoRefreshCartDrawer = function (openAfter) {
  fetch('/?sections=cart-drawer-section')
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var html = data['cart-drawer-section'];
      var target = document.getElementById('shopify-section-cart-drawer-section');
      if (html && target) {
        var wrapper = document.createElement('div');
        wrapper.innerHTML = html;
        var newEl = wrapper.firstElementChild;
        if (newEl) target.replaceWith(newEl);
      }
      window.keoUpdateCartBadge();
    })
    .finally(function () {
      if (openAfter) {
        var trigger = document.querySelector('[aria-controls="cart-drawer"]');
        if (trigger) trigger.click();
      }
    });
};

// Delegated so it keeps working after keoRefreshCartDrawer replaces the
// cart-drawer-section DOM node.
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-keo-upsell-add]');
  if (!btn) return;
  btn.disabled = true;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: btn.dataset.variantId, quantity: 1 })
  }).then(function (r) { return r.json(); }).then(function () {
    window.keoRefreshCartDrawer(true);
  }).finally(function () { btn.disabled = false; });
});


// Product card quick add (rails, grids, related products).
(function () {
  function closeAll(except) {
    document.querySelectorAll('[data-keo-qa-card].is-qa-open').forEach(function (card) {
      if (card === except) return;
      card.classList.remove('is-qa-open');
      var sizes = card.querySelector('[data-keo-qa-sizes]');
      if (sizes) sizes.hidden = true;
      var open = card.querySelector('[data-keo-qa-open]');
      if (open) open.setAttribute('aria-expanded', 'false');
    });
  }

  function openCard(card) {
    closeAll(card);
    card.classList.add('is-qa-open');
    var sizes = card.querySelector('[data-keo-qa-sizes]');
    if (sizes) sizes.hidden = false;
    var open = card.querySelector('[data-keo-qa-open]');
    if (open) open.setAttribute('aria-expanded', 'true');
    var first = card.querySelector('.keo-product-card__size:not([disabled])');
    if (first && card.matches(':focus-within')) first.focus({ preventScroll: true });
  }

  function add(btn) {
    var card = btn.closest('[data-keo-qa-card]');
    var original = btn.textContent;
    btn.classList.add('is-loading');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: btn.dataset.variantId, quantity: 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      if (btn.classList.contains('keo-product-card__quick-add')) btn.textContent = 'Added ✓';
      if (window.keoRefreshCartDrawer) window.keoRefreshCartDrawer(true);
      setTimeout(function () {
        btn.classList.remove('is-added');
        btn.textContent = original;
        if (card) closeAll(null);
      }, 1400);
    }).catch(function () {
      btn.classList.remove('is-loading');
      if (btn.classList.contains('keo-product-card__quick-add')) {
        btn.textContent = 'Try again';
        setTimeout(function () { btn.textContent = original; }, 1600);
      }
    });
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-keo-qa-open], [data-keo-qa-touch]');
    if (openBtn) {
      e.preventDefault();
      var card = openBtn.closest('[data-keo-qa-card]');
      var single = card && !card.querySelector('[data-keo-qa-sizes]');
      if (single && openBtn.hasAttribute('data-keo-qa-touch')) {
        var only = card.querySelector('[data-keo-qa-add]');
        if (only) add(only);
        return;
      }
      if (card) openCard(card);
      return;
    }
    var addBtn = e.target.closest('[data-keo-qa-card] [data-keo-qa-add]');
    if (addBtn) {
      e.preventDefault();
      if (!addBtn.disabled) add(addBtn);
      return;
    }
    if (!e.target.closest('[data-keo-qa-card]')) closeAll(null);
  });

  document.addEventListener('submit', function (e) {
    if (e.target.matches('[data-keo-qa-form]')) e.preventDefault();
  });

  document.addEventListener('mouseleave', function (e) {
    var card = e.target && e.target.closest && e.target.closest('[data-keo-qa-card].is-qa-open');
    if (card && e.target === card && window.matchMedia('(hover: hover)').matches) closeAll(null);
  }, true);

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
})();
